import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'EarlyAccessDomain' })({
  input: {
    background: 'initial',
    backgroundColor: 'white',
  },
});
